module.exports = __webpack_public_path__ + "static/media/no_filter.c8e8ab87.svg";